module.exports = __webpack_public_path__ + "media/Background_Page_Accueil_Essai3_Reduced_size.b3cf83cb.mp4";